"use client";

import Link from "next/link";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import LiveCounter from "./LiveCounter";
import SMSPhone from "./SMSPhone";
import { track, HOME_EVENTS } from "@/lib/analytics";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-white pt-32 pb-20 sm:pt-40 sm:pb-28 aura">
      <div className="relative z-10 mx-auto grid max-w-6xl gap-14 px-6 lg:grid-cols-[1.1fr_0.9fr] lg:items-center lg:gap-12">
        <div>
          <motion.p
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="ribbon mb-5 text-ink-500"
          >
            For local businesses drowning in Google reviews
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.05 }}
            className="font-display text-5xl font-extrabold leading-[1.05] tracking-tight text-ink-950 sm:text-6xl lg:text-7xl text-balance"
          >
            Never open your laptop
            <br />
            to reply to a Google review{" "}
            <em className="font-display italic font-normal text-brand-600">
              again
            </em>
            .
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="mt-6 text-lg leading-relaxed text-ink-600 sm:text-xl text-pretty"
          >
            Free to start. AI drafts every reply. Pay $19.99/month only when
            you&rsquo;re ready to post — no SMS, no credit card to try.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.25 }}
            className="mt-9 flex flex-col items-start gap-4 sm:flex-row sm:items-center"
          >
            <Link
              href="/tools/review-health-check"
              onClick={() =>
                track(HOME_EVENTS.HERO_CTA_CLICK, {
                  destination: "/tools/review-health-check",
                  label: "Grade my reviews",
                })
              }
              className="approve-btn inline-flex items-center gap-2 rounded-xl bg-ink-950 px-7 py-4 text-base font-bold text-white shadow-lg hover:bg-ink-900"
            >
              Grade my reviews
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Link>
            <Link
              href="/auth/signin"
              onClick={() =>
                track(HOME_EVENTS.HERO_CTA_CLICK, {
                  destination: "/auth/signin",
                  label: "Start free",
                })
              }
              className="inline-flex items-center gap-2 rounded-xl border-2 border-ink-200 bg-white px-7 py-4 text-base font-bold text-ink-900 hover:border-ink-300 hover:bg-ink-50"
            >
              Start free — connect your Google profile
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mt-7"
          >
            <LiveCounter />
          </motion.div>
        </div>

        <div className="flex justify-center lg:justify-end">
          <SMSPhone />
        </div>
      </div>
    </section>
  );
}
